<template lang='pug' src='./slider-home.pug'></template>

<script>

export default {
  props: ['props'],
  data () {
    return {
      swiperOption: {
        slidesPerView: 2,
        breakpoints: {
          768: {
            slidesPerView: 1
          }
        },
        autoplay: {
          delay: 5000
        },
        loop: true,
        simulateTouch: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        spaceBetween: 10,
        pagination: {
          el: '.slider-home__pagination',
          clickable: true,
          bulletClass: 'slider-home__bullet',
          bulletActiveClass: 'slider-home__bullet-active',
          renderBullet: function (index, bulletClass) {
            return '<div class="' + bulletClass + '"></div>'
          }
        },
        navigation: {
          nextEl: '.swiper-wrapper'
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// slider-home.vue?300dab32